import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../../../components/AppIcon';
import StoreIcon from '../../../../../../components/StoreIcon';

const SelectedApp = ({ app, size = 32, className, onRemove }) => (
  <div className={cx('selected-app-container', className)}>
    <div className="selected-app">
      <StoreIcon store={app.store} />
      <AppIcon
        url={app.icon_url}
        store={app.store}
        size={size}
        alt={app.name}
        containerClasses="selected-app__icon"
        hideHtmlTitle
        withBorder
      />
      <p className="selected-app__name">{app.name}</p>
      <span className="hicon-close" onClick={() => onRemove(app)} />
    </div>
  </div>
);

SelectedApp.propTypes = {
  app: T.shape({
    store: T.string,
    icon_url: T.string,
    name: T.string,
  }).isRequired,
  size: T.number,
  className: T.string,
  onRemove: T.func.isRequired,
};

export default SelectedApp;
